var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.667 10.429c0-2.131 1.716-3.858 3.833-3.858c2.117 0 3.833 1.727 3.833 3.858h-7.666Zm-2.556 0h-3.833c-0.706 0-1.278 .575-1.278 1.285v18c0 .71 .572 1.286 1.278 1.286h20.444c.706 0 1.278-0.576 1.278-1.286v-18c0-0.71-0.572-1.285-1.278-1.285h-3.833c0-3.551-2.861-6.429-6.389-6.429c-3.529 0-6.389 2.878-6.389 6.429Zm2.556 5.142c0 2.131 1.716 3.858 3.833 3.858c2.117 0 3.833-1.727 3.833-3.858h2.556c0 3.551-2.861 6.429-6.389 6.429c-3.528 0-6.389-2.878-6.389-6.429h2.556Z",
    fill: "#ffc300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPass);
export default __webpack_public_path__ + "static/media/ic_pass.b8047021134c439b113a9479430238c6.svg";
export { ForwardRef as ReactComponent };